import { get, post } from '@/request/http'

// 登录接口
export const login = (params) => post('/api/admin/login', params)
//退出接口
export const loginOut = (params) => post('/api/admin/logout', params)

export const updatePsw = (params) => post('/api/admin/updateadminuserpw', params)
//获取单个后台用户
export const getadmin = (params) => get('/api/admin/getadminuserbyid', params)

//修改个人资料
export const updateadminuserinfo = (params) => post('/api/admin/updateadminuserinfo', params)

//获取角色详情
export const getRoleMenu=(params)=>get('/api/admin/getrolebyid',params)
//菜单接口2
export const getMenu2 = (params) => get('/api/admin/getmenus2', params)


// WEBPACK FOOTER //
// ./src/api/userMG.js